import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'isBetweenTimes'
})
export class IsBetweenTimesPipe implements PipeTransform {
  transform(today: string, startTime: string, endTime: string): boolean {
    if (!today || !startTime || !endTime) {
      return false;
    }
    const todayTime = dayjs().set('hour', Number(today.split(':')[0])).set('minute', Number(today.split(':')[1]));
    const start = dayjs().set('hour', Number(startTime.split(':')[0])).set('minute', Number(startTime.split(':')[1]));
    const end = dayjs().set('hour', Number(endTime.split(':')[0])).set('minute', Number(endTime.split(':')[1]));

    return todayTime.isAfter(start) && todayTime.isBefore(end);
  }
}

